import type { NextOptions } from '../../interfaces';

export const nextOptionDefaults: NextOptions = {
  error: null,
  bail: false,
  using: [],
};
